import { injectable } from 'inversify';

@injectable()
export class Locale {
  public getlocale(): string {
    try {
      const lang = document.documentElement.lang;

      switch (lang) {
        case 'fr':
        case 'de':
        case 'ko':
        case 'pl':
        case 'es':
        case 'it':
        case 'zh':
          return lang;
        default:
          return 'en';
      }
    } catch (e) {
      return 'en';
    }
  }

  public getAllLocales(): Array<String> {
    return ['en', 'fr', 'es'];
  }
}
